export const state = () => ({
  list: []
})

export const getters = {
  list: (state) => state.list || []
}

export const mutations = {
  setList: (state, payload) => (state.list = payload),

  createItem(state, payload) {
    state.list = [...state.list, payload]
  },

  updateItem(state, payload) {
    const f = state.list.findIndex((item) => item.id === payload.id)

    if (f !== -1) {
      state.list = [
        ...state.list.slice(0, f),
        payload,
        ...state.list.slice(f + 1)
      ]
    }
  },

  deleteItem(state, payload) {
    const f = state.list.findIndex((item) => item.id === payload)

    if (f !== -1) {
      state.list = [...state.list.slice(0, f), ...state.list.slice(f + 1)]
    }
  }
}

export const actions = {
  // fetch(_, payload) {
  //     return this.$api
  //         .get("/gallery/list", {
  //             params: payload
  //         })
  //         .then((res) => {
  //             if (res && res.data) {
  //                 //  commit('setList', res.data)
  //                 return res.data
  //             }

  //             return []
  //         })
  //         .catch((err) => {
  //             console.log(err)
  //             return []
  //         })
  // },
  fetchPhoto(_, payload) {
    return this.$api
      .get("/admin/gallery/photo-gallery/list/", payload)
      .then((res) => {
        return res && res.data
      })
  },

  fetchVideo(_, { params }) {
    console.log(params)
    return this.$api
      .get("/admin/gallery/video-gallery/list/", {
        params
      })
      .then((res) => {
        // console.log("video", res)
        return res && res.data
      })
  },

  detail(_, payload) {
    return this.$api
      .get(`/admin/gallery/${payload.type}-gallery/${payload.id}/update/`)
      .then((res) => {
        if (res && res.data) {
          return res.data
        }

        return {}
      })
      .catch((err) => {
        console.log(err)
        return {}
      })
  },
  createItemActionPhoto(_, payload) {
    return this.$api
      .post("/admin/gallery/photo-gallery/create/", payload.data)
      .then((res) => {
        // commit('createItem', res.data)
        return res
      })
      .catch((err) => {
        console.log(err)
        return err
      })
  },

  updateItemActionPhoto(_, payload) {
    return this.$api
      .patch(
        "/admin/gallery/photo-gallery/" + payload.id + "/update/",
        payload.data
      )
      .then((res) => {
        // commit('updateItem', res.data)
        return res
      })
      .catch((err) => {
        console.log(err)
        return err
      })
  },

  removeItemAction(_, payload) {
    console.log("Delete", payload)
    return this.$api
      .delete("/admin/gallery/photo-gallery/" + payload + "/delete/")
      .then((res) => !!(res && res.status >= 200))
      .catch((err) => {
        console.log(err)
        return false
      })
  },
  createItemActionVideo(_, payload) {
    return this.$api
      .post("/admin/gallery/video-gallery/create/", payload.data)
      .then((res) => {
        // commit('createItem', res.data)
        // console.log(res)
        return res
      })
      .catch((err) => {
        console.log(err)
        return err
      })
  },

  updateItemActionVideo(_, payload) {
    // console.log(payload)
    return this.$api
      .patch(
        "/admin/gallery/video-gallery/" + payload.id + "/update/",
        payload.data
      )
      .then((res) => {
        // commit('updateItem', res.data)
        return res
      })
      .catch((err) => {
        console.log(err)
        return err
      })
  },

  removeItemActionVideo(_, payload) {
    console.log(payload)
    return this.$api
      .delete(`/admin/gallery/video-gallery/${payload.id}/delete/`, {
        videos: [payload.galleryId]
      })
      .then((res) => !!(res && res.status >= 200))
      .catch((err) => {
        console.log(err)
        return false
      })
  }
}
